import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import Loading from 'components/Loading';
import { getStartupVerifiedIcon } from 'utils/functions';
import './styles.scss';

function PopupVerify(props) {
  const {
    title,
    options,
    onSubmit,
    onClose,
  } = props;

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (ids, type) => {
    setLoading(true);
    try {
      await onSubmit(ids, type);
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popup title={title} onClose={onClose} size='small'>
      {loading ? <Loading mode='panel' /> : (
        <ul className='verify-list'>
          {options.map((option) => (
            <div className='box box-padding' onClick={() => handleSubmit(option.id)}>
              <div className='d-flex'>
                <h6 className='fw-b mb-0'>{option.title}</h6>
                {getStartupVerifiedIcon(option.id)}
              </div>
              {option.subtitle && <span className='fs-sm'>{option.subtitle}</span>}
            </div>
          ))}
        </ul>
      )}
    </Popup>
  );
}

PopupVerify.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PopupVerify;
